export default __webpack_public_path__ + "static/media/rupee.f176c8ae.svg";